
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h0e60f0986075c2fd': html`Al solicitar esta licencia, Tenable podrá enviarle comunicaciones por correo electrónico sobre sus productos y servicios. Puede optar por no recibir estas comunicaciones en cualquier momento utilizando el enlace para darse de baja situado en el pie de página de los correos electrónicos que se le envían. También puede gestionar sus preferencias de correo electrónico de Tenable visitando la <a target="_blank" href="https://info.tenable.com/SubscriptionManagement.html">página de gestión de suscripciones</a>.`,
'h5d94556d32fdee9e': html`Tenable solo procesará sus datos personales de acuerdo con su <a target="_blank" href="https://www.tenable.com/privacy-policy">Política de privacidad</a>.`,
'h97a056af7968d75c': html`Al registrarse para esta licencia de prueba, Tenable podrá enviarle comunicaciones por correo electrónico sobre sus productos y servicios. Puede optar por no recibir estas comunicaciones en cualquier momento utilizando el enlace para darse de baja situado en el pie de página de los correos electrónicos que se le envían. También puede gestionar sus preferencias de correo electrónico de Tenable visitando la <a target="_blank" href="https://info.tenable.com/SubscriptionManagement.html">página de gestión de suscripciones</a>.`,
'hb2f7081d6bbb9ba0': html`Acepto los <a href="https://static.tenable.com/prod_docs/tenable_slas.html">acuerdos de licencia de software</a> de Tenable.`,
's09205907b5b56cda': `No`,
's0a33de57b0d31a11': `Administrador de sistemas/TI`,
's0adb3f5e5e594e43': `El título del curso es obligatorio`,
's0f3489ff0bc2e14f': `Se debe cargar un PDF`,
's0fbf6dc6a1966408': `Siguiente`,
's12e486740e2e33fc': `El nombre de la organización es obligatorio`,
's150bac76e4f85b3c': `La región es obligatoria`,
's15361efa1eef6aee': `Comenzar`,
's1cdeecda0baf365e': `Lanzar`,
's1dda911063939e05': `Se extendió su prueba.`,
's1ed5c670ff346e93': `El comentario es obligatorio`,
's1f5a2beee27d45e7': `Es posible que un cliente haya avanzado entendiendo que tenía autorización de alguien de su organización para realizar el escaneo. Confirme haber verificado con las partes interesadas del negocio relacionadas si se autorizó este escaneo.`,
's24233c7c75e9ee19': `Tenga en cuenta que los comentarios se refieren únicamente a la documentación y no a los productos de Tenable.`,
's2468b69d10791c82': `Ciudad`,
's27707a7616f7f789': `El nombre es obligatorio`,
's27cc88818cc46ff6': `Estable`,
's2c57913ffd36d298': `Nombre`,
's2ea2118efa449d32': `Cargar PDF de la documentación o programa del curso`,
's2eb3c51d71b9f608': `Formato de código de activación no válido`,
's30699ee91122500e': `En breve nos pondremos en contacto con usted.`,
's31008bbe2c3076e5': `Tamaño de la empresa (empleados)`,
's32fc186d3b40fb7d': `Nombres de la organización`,
's335aa28c009aaa99': `Desarrollador de software/QA`,
's38858d6849510272': `Durante el proceso de instalación se le enviará un correo electrónico para validar su dirección de correo electrónico.`,
's39888fc990ed085e': `Debe consultar a las partes interesadas para continuar.`,
's3b8dc2a2dfe650e3': `Una vez que envíe este formulario, investigaremos cuál de nuestros clientes inició esta actividad de escaneo. Indique a continuación una dirección de correo electrónico para que podamos ponernos en contacto con usted una vez finalizada la investigación.`,
's404951d60833268e': `La URL de la página es obligatoria`,
's42cbd8dca939a9c7': `Consultar`,
's4362571c6638089a': `El nombre del programa de capacitación/escuela es obligatorio`,
's483a20681be190ae': `Título del curso`,
's4f2540795dacf546': `Supera el tamaño máximo de comentario`,
's5209870f843f5cd1': `Las IP de destino no pueden estar en blanco`,
's5855112288e12328': `El título es obligatorio`,
's5b7873343b9dc4eb': `¿En qué fecha/hora (en su zona horaria local) se detuvo el escaneo no autorizado?`,
's5d0cc12e0667faa7': `Nombre del programa de capacitación/escuela`,
's5ef6d725815017ce': `¿Qué IP fueron objeto del escaneo no autorizado?`,
's686306cdb839fb8d': `Enviando…`,
's69c584ac95443bc2': `Estudiante/Instructor`,
's6b986b4370cf95cf': `Proporcione la siguiente información para crear una cuenta e iniciar su prueba.`,
's6b9a88ee6c526aa4': `Las IP de origen no pueden estar en blanco`,
's6dcf1b198660d558': `¿Le ha ayudado esta página?`,
's6faf53a851ae1ef8': `Dirección de correo electrónico no válida`,
's745d8397b36781a7': `Para iniciar una prueba, proporcione la dirección de correo electrónico de su empresa.`,
's76b6c6ef5bc06202': `Disponibilidad general`,
's776925a2c81b7a63': `Correo electrónico profesional`,
's78df1fa22c512d7d': `Comentario (opcional)`,
's79df2775a8139811': `El acuerdo de términos es obligatorio`,
's7cb4e55c59663b1c': `Empresa`,
's80a0e23d9c7eea56': `La dirección es obligatoria`,
's81ec7a6847534d5e': `Volver atrás`,
's85e492de89c8ae2c': `El tamaño de la empresa es obligatorio`,
's8868de3e06abe230': `Correo electrónico no válido`,
's8a830d13f8d3298b': `Iniciar prueba`,
's912d50b0bb095241': `La dirección de correo electrónico no puede estar en blanco`,
's95a75a2392af5780': `Apellido`,
's99f110d27e30b289': `Título`,
's9cf7402fe920f7d1': `País`,
'sa21690c4800aeb69': `La ayuda de la página es obligatoria`,
'sa4343664d7b15d0c': `Cargar PDF del estado sin fines de lucro`,
'sa4cdfd30561e69a1': `Nombre no válido`,
'sa9c6d50e25c88911': `El apellido es obligatorio`,
'sae96e6ca5de9220c': `El código de activación no puede estar en blanco`,
'saf84ec86139d349e': `Comentario`,
'sb326f1c1bf700835': `Yo soy...`,
'sb37fd819bd638708': `Deje un comentario`,
'sb3d4f79d9d8b71e5': `Enviar`,
'sb51270e19988f9bd': `Región`,
'sb7567af23b8f5703': `¡Gracias!`,
'sb7c9b2995d6869b1': `El apellido es obligatorio`,
'sb839a044bb672d70': `El país es obligatorio`,
'sbaf0ff2390822c90': `Su producto tiene ahora activada la evaluación de Nessus Expert.`,
'sbd66ac1792782ee6': `Para iniciar la prueba, descargue e instale Nessus.`,
'sbde039f6fe3847bf': `La fecha de inicio no puede estar en blanco`,
'sc16e00a7a8b2fde2': `Atrás`,
'sc46caeb9d1bc8fc6': `Envío fallido`,
'sc9446ac9849aa293': `Código postal`,
'scb489a1a173ac3f0': `Sí`,
'scf226d2c20f172c2': `El teléfono es obligatorio`,
'sd1ae08b28f9defa9': `La fecha de finalización no puede estar en blanco`,
'sd1f44f1a8bc20e67': `Correo electrónico`,
'sd33e190b8e41dc5f': `¿Cuáles fueron las IP de origen del escaneo no autorizado?`,
'sd3d0ca1bec5003d7': `La ciudad es obligatoria`,
'sda8ea7031a8a7d69': `El nombre es obligatorio`,
'sdc79ece8adeaa363': `Apellido no válido`,
'sdcf8c65961c70674': `Lo verifiqué con las partes interesadas del negocio y este escaneo no estaba autorizado.`,
'sde6ffc33e0ca1f9b': `Utilice la notación CIDR (es decir, 0.0.0.0/24 o 1.1.1.1/32)`,
'sdf1b17585b7725b5': `Aficionado/Uso personal`,
'sdfb2b12b255de30c': `Copiado`,
'se032693d59c82e26': `Código de activación`,
'se1ad99292eaa4000': `Enviar solicitud`,
'se4c692301c655018': `Es necesario el rol`,
'se7c56a68f0ecf6e9': `Enviando...`,
'se8563c7e9107f391': `Dirección IP no válida`,
'sed7161a6bc9e01f6': `La dirección de correo electrónico es obligatoria`,
'sedabde95323d0cc2': `Correo electrónico no válido`,
'sf1af788523eecd55': `Descargar ahora`,
'sf1bc83d2509bafcf': `Teléfono`,
'sf1d7c751277ec33c': `Gracias por sus comentarios.`,
'sf4122b220926be97': `Versión`,
'sf5d5953a8e441bce': `Marque para recibir actualizaciones de Tenable`,
'sf820da2caa9be44b': `¿En qué fecha/hora (en su zona horaria local) comenzó el escaneo no autorizado?`,
'sf8e87dc100579c22': `Usted se está registrando para una licencia de 30 días de Nessus Essentials.`,
'sf9286dfc7b09c4c3': `Dirección de correo electrónico prohibida/Dirección de correo electrónico no válida`,
'sfb904441a4b2573f': `Consultor de seguridad/Evaluador de penetración`,
'sfcdd8e672c75b713': `Dirección`,
'sfd76061a1ae701dd': `La empresa es obligatoria`,
'sff6467521565aa6d': `El producto es obligatorio`,
'sffe2914d4b7c91ee': `Acceso anticipado`,
's5f7a4982df278fbe': `Customer Name cannot be blank`,
's77d3ba42477d1e37': `Customer Email cannot be blank`,
's67da547a401b53a2': `Customer Organization cannot be blank`,
's4c672206f89e3a5a': `Output of OS Fingerprint plugin cannot be blank`,
's7e2003487616c0be': `Actual operating system and version running on asset cannot be blank`,
'sd2b571fd3bc03be2': `Product category cannot be blank`,
'sf1e5f5e4fdd3bba0': `Customer Name`,
's23a3125df912b8f9': `Customer Email`,
'se931b3bbed6e76fc': `Customer Organization`,
'scbf29ce484222325': ``,
's5d348d92f624a8d4': `Output of OS Fingerprint plugin`,
'sa425ce5a226eaca0': `Actual operating system and version running on asset`,
's5af6ae0f37cdcebc': `Product category`,
'sa5e110bf579cf0c0': `First name is a required field`,
's0e6648bcb9d5af68': `Last name is a required field`,
's11210461aa0897f5': `Invalid job title`,
'sc6175309159cd892': `Job title is a required field`,
'sce9b172fc76157dc': `Email address must be at most 128 characters`,
'sbf38b62ad692ac35': `Invalid phone number`,
'sbbcb2eaae4ba066d': `Phone number must be at least 7 characters`,
's1fb28070fa0f05ed': `Phone number must be at most 21 characters`,
's7c13503ca24eba56': `Phone number cannot be blank`,
'sa7e435619598b636': `Invalid company name`,
'sb552be5d0c770ee0': `Company name must be at most 128 characters`,
's6d8731ef96677585': `Company name cannot be blank`,
's1afa07c2b66ff62b': `Invalid company local name`,
's506eaeb84f6393af': `Company local name must be at most 128 characters`,
's057f50cfeec7a5d4': `Company local name cannot be blank`,
'scdf406c62ac459ee': `Invalid company street`,
's431cb6159458aff6': `Company street must be at most 100 characters`,
'scfe5367b825aa021': `Company street cannot be blank`,
'sf2861d48ce187dfc': `Address Line 2 must be at most 100 characters`,
'se0d51d38197e07d2': `Invalid company city`,
's2895a162278dde31': `Company city must be at most 80 characters`,
'se63c510747161309': `Company city cannot be blank`,
's6df2a5cef3d1720a': `Invalid country`,
'sb86c7d0873869d8a': `Country must be at most 3 characters`,
's42e34144d02046cf': `Country cannot be blank`,
'sb69db5255038cc06': `Invalid company state`,
's4181c88a1d6bcbc3': `Company state must be at most 80 characters`,
's079bd93b0a95b747': `Company state cannot be blank`,
'sde2e929c895a2bc4': `Invalid company zip`,
's630f692c9a3c1497': `Company zip must be at most 15 characters`,
's47276834fdf83c99': `Company zip cannot be blank`,
's640750ff3bc6df5a': `Invalid company website`,
's78ed21b20be786b6': `Company website must be at most 128 characters`,
'sc565ad20a5499cbf': `Company website cannot be blank`,
's43d15411b0049a45': `Invalid company domiciled country`,
's058e244536ea41ca': `Company domiciled country must be at most 64 characters`,
'sf9843fbbb9897d84': `Company domiciled country cannot be blank`,
's6f75c94f62fb1878': `Invalid vendor country`,
's63595d0dae6e7dff': `Vendor countries cannot be blank`,
's6462b07855ecfd44': `Invalid email domain(s)`,
'sf3d1bf51f11a3291': `Email domain(s) cannot be blank`,
's5afb9b77f036fdd0': `Invalid Nominated Distributor`,
's7b9492fe0525dad7': `Nominated Distributor is a required field`,
's6603adf5fc045764': `Invalid MSSP admin email`,
's363ea1128d3466fa': `MSSP admin email must be a valid email address`,
's17ceb32d219a1ff3': `MSSP admin email cannot be blank`,
's4bf0ae3aa8b8efe8': `Invalid MSSP first name`,
's210ac90826f31882': `MSSP first name must be at most 32 characters`,
's267594beb5b752bd': `MSSP first name cannot be blank`,
'sb42935bf7c97ff50': `Invalid MSSP last name`,
'sebd16182dac5d87c': `MSSP last name must be at most 32 characters`,
's200a89fb16868883': `MSSP last name cannot be blank`,
's94e262ec8196a8d2': `Select a Country first`,
's49730f3d5751a433': `Loading...`,
's8494ea586799a7c7': `No Distributors available`,
'sc402697a94f9fa0f': `Select a Distributor`,
'sc1cb53f373bb116e': `Please enter your company information below.`,
's04a485fa1bfb57aa': `By entering your contact information, you will receive notice of your application status and will be the main point of contact for Tenable.`,
's759d499e3f98e1e3': `Job Role / Title`,
'sbc7991afd390f262': `Company Information`,
's6eadf529cf3dfe8f': `Company Name`,
's2d538acd13a635a7': `Have different company name in local language?`,
's09b0a8354c3df5ae': `Company Legal Name in Local Language`,
's5de3266c6bef9ab2': `Street Address`,
's08985cf1f4934f2c': `Street Address 2`,
's6e8610efa513a16d': `State / Region`,
's22f2ed91b6a04187': `Nominated Distributor`,
's664ada7bc62bc93e': `Company Domiciled Country`,
's1b066f06d88bf4f2': `Countries Where Company is a Vendor`,
'sbbaaa33bb75d4281': `Company Website`,
'sd14e73e9ad6f1a48': `Company Domain(s)`,
's187afa9d86ba4715': `Will you be selling Tenable products or services, directly or indirectly, to government entities?`,
's2c6fc39f355e32e8': `MSSP Information`,
's884966926eae543f': `I would NOT like to be enrolled in Tenable's MSSP Portal`,
's5414a284bad4b347': `MSSP First Name`,
'sad4183cf022cb0dd': `MSSP Last Name`,
's78478f0c9da3486d': `MSSP Admin Email`,
'sf3ff78cc329d3528': `Previous`,
'sb79dbff3fb74227d': `First name must be at most 32 characters`,
's1f44a3f6d5b2efa5': `Last name must be at most 32 characters`,
's3d24f8b80807590c': `Must be a valid email address`,
's0e0d1ffcf8cf88e3': `A requirement for entry into the Tenable Assure Partner Program is completing a Third Party Risk Questionnaire. To receive this questionnaire, please provide us with the name and email address of a contact in your organization who can complete it. Upon submission of this completed application, the contact provided will receive two emails.`,
'sb0a2bd5eaab699f8': `First email will be from`,
's0e5e5fc41e53cb0f': `with instructions on next steps`,
'scd5be91c82622f5c': `Second email will be from`,
's319c30051338df88': `with activation instructions`,
's1fa8f60b5865e873': `Invalid name`,
's030fd9cd6b09ab72': `Name must be at most 64 characters`,
's54f2990d945f7016': `Name is a required field`,
's044787c9f834f426': `Invalid title`,
's96c2c7ba222ef488': `Title must be at most 32 characters`,
'sf5e1d4f892eae2d1': `Title is a required field`,
'sf0639fc45e73ca9d': `Please review the terms of the Tenable Assure Partner Program agreement.`,
's6b3bd4b9cbaaf690': `To accept the terms on behalf of your organization, please enter your information below.`,
'sb5979f1c1ff4bb75': `Download Agreement`,
's4da94997a0786775': `Accepted By:`,
'sef49aec68fd1dc66': `Name`,
's1e2e135dac5ba993': `Email Address`,
's7a3d4475a1898437': `I have read and agree to the terms contained in the`,
'sbecc61a45036d26c': `Tenable Master Partner Agreement`,
'sa071899bfcff2b15': `Please review the terms of the Tenable MSSP agreement.`,
's4c4866fae850191b': `Tenable MSSP Agreement`,
's3a6884c05fc91a67': `Application Type`,
's64ef2a6c2dd1d3d1': `Edit`,
'sd3750a98ad7d185f': `Company Legal Localized Name`,
's4995934111df67d2': `Countries Where Company Provides Service`,
's7f28de9995ad07f7': `Selling To Government`,
's5380afc3b1637319': `Contact Information`,
'sd6697df5d4dd1914': `Contact First Name`,
's8090b6c6f3cba1a4': `Contact Last Name`,
'sbcf28c2075fccf53': `Contact Phone`,
'sea0d9a214aa5fd30': `Enroll in MSSP Portal?`,
's8332bf5556277e4e': `MSSP Admin Contact First Name`,
'se7f59d28eb0c33da': `MSSP Admin Contact Last Name`,
'sdfe69b46156cbd49': `MSSP Admin Contact Email`,
'sfaae2ea61416fcd7': `MSSP Management Tenable Customer ID`,
's84d6182701341128': `Third Party Risk Questionnaire`,
'secb1a09a94ac29b3': `Questionnaire Contact First Name`,
's5717ec77712c3311': `Questionnaire Contact Last Name`,
's380dcacf52799c56': `Questionnaire Contact Email`,
's132a4bc1104a7bde': `Legal Info`,
'se11cc742e1c65b48': `Tenable Master Partner Agreement Accepted By:`,
's5d6b15bddedcd48d': `Job Role /Title`,
's28cc834e26fcaa11': `Tenable MSSP Agreement Accepted By:`,
's4e8b2e4d0c92d0a2': `Thank you for submitting your application to join the Tenable Assure Partner Program.`,
's081ec085d7f7290d': `Your application is being reviewed and you will be notified shortly if your application is accepted.`,
'sf6520d7bcd621295': `Select Application Type`,
'sc9d9893b31d60276': `Please Enter Your Information`,
's0b2549ed7b4b302b': `Compliance - Third Party Risk`,
's86aa26c374736620': `Tenable Agreement`,
'sdc52e52ee7b8ee6a': `MSSP Agreement`,
's177ec534112b9c73': `Review Application`,
's63f5b9c451b08734': `Confirmation`,
's73b125aabf2a94c7': `Questions?`,
's096321dc4158f5e1': `Invalid First Name`,
's6090cfcdc83bb25d': `First Name must be at most 32 characters`,
'seb43b1811ee577a0': `First Name is a required field`,
's03cf76478d8c5163': `Invalid Last Name`,
'sd72a430be5eae585': `Last Name must be at most 32 characters`,
'sf136e4b7ae959cc8': `Last Name is a required field`,
's15a3588cc7415e78': `Invalid Email`,
's3dbf526157f4353c': `Email Address must be at most 128 characters`,
's4ce2a09f9e6659b7': `Email is a required field`,
's1fe066d54c8f0a86': `Invalid Title`,
's1755b7d51509274c': `Invalid Phone`,
's237fe5ac53851606': `Phone must be at least 7 characters`,
'sb5bd69371e52fa1a': `Phone must be at most 21 characters`,
'sbab8872b5149a0bf': `Phone is a required field`,
's17e6695a3a2874f6': `Invalid Company Name`,
's2cfef87a8a8afcc0': `Company Name must be at most 128 characters`,
's2376584a4e2c2a7f': `Company Name is a required field`,
'sd207c05fa97d731a': `Invalid Company Website`,
's453cdfbe7cd69816': `Company Website must be at most 128 characters`,
's39a0512fff76c809': `Company Website is a required field`,
's98dff22b137329ae': `Invalid Company Street`,
'sdc30455dbcd835d6': `Company Street must be at most 100 characters`,
's05ee0d4139363633': `Company Street is a required field`,
's5328e40b8e66dfe8': `Invalid Company Street 2`,
's00948442df381e1c': `Company Street 2 must be at most 100 characters`,
's4d715130bb2a9d92': `Invalid Company City`,
'sf2a272e4b9669211': `Company City must be at most 80 characters`,
's3395ced5f92f5a1b': `Company City is a required field`,
's50323d97ea17ed6a': `Invalid Country`,
's4a28122e23fa65f9': `Country is a required field`,
's9f6e3c4ebabc81c6': `Invalid Company State`,
's93d2cc5297ff6207': `State / Region must be at most 80 characters`,
'sfad08d5ac0049ed9': `Please select an option from the dropdown`,
'sd81fe9740eff55e5': `State / Region is a required field`,
'sfddf7ba1d0f09284': `Invalid Company Zip`,
's4c4691beb394df7f': `Postal Code must be at most 15 characters`,
's2a84f3d795b19253': `Postal Code is a required field`,
's9685b2793ed74d37': `Invalid Number of Employees`,
'sb59ec9e7fb637a08': `Number of Employees is a required field`,
's842bdfce4bf10575': `Invalid Joint Customers`,
'sdc99de4822159e9e': `Joint Customers is a required field`,
'sfb9fa624cd92ea4e': `Invalid Product Name`,
'se75f4d7f4b30c0ef': `Product Name is a required field`,
's9ed281404cad82d9': `Invalid Product Category`,
'sce36caa10cd8a574': `Product Category is a required field`,
's216913f6b4aa6e9b': `Invalid Product Interest`,
's58ae06029972cfa6': `Product Interest is a required field`,
's00d8da892a4c0a4d': `Invalid Use Case`,
's5bbe70c97892f4b8': `Use Case is a required field`,
's511690590166bdc0': `Number of Employees`,
'sad6f77bdb93a08ce': `Joint Customers`,
's824e76df2a9fed56': `Product Interest`,
'se98d4f7d441d9f69': `Name of your Product`,
's403fcc2bf6e199dc': `Product Category`,
'sf417ed28e1be2c45': `Tenable Product you are interested in integrating with?`,
's6e72a35b40ee1510': `Use Case`,
's87bae2710b2492c3': `Contact`,
'sd4f07a55a9d19c01': `with any questions about this agreement`,
's27ec1b56fc9d4657': `Tenable MSLA Agreement`,
'se8bb85b38adead5a': `Please review the information you have provided prior to submitting the application:`,
's225b3056215198f4': `Product Interest Information`,
'sb7cde9a0f3abe0ff': `Compliance &amp; Legal Info`,
's8a5a81077ef0f812': `Thank you for applying to the Tenable Tech Alliances Program.`,
'sd240950ab5f5b0ad': `Unfortunately at this time your organization does not qualify to be part of the Tech Alliances program.`,
's51ede26cfcc829f8': `If you have any questions please contact`,
's65869ad0cffa2abb': `for more information.`,
's98ce26d73b9105dc': `Thank You,`,
's252d28242b02ee87': `Tenable Tech Alliances Team`,
's9fa62939ff61fb01': `Thank you for submitting your application to join the Tenable Tech Alliances Program.`,
'sb90d2fe944963537': `Compliance Questions`,
's5c0a9eb7dfb98536': `First Name cannot be blank`,
's02aa50806450b61e': `Last Name cannot be blank`,
'sa39f0be64bdbf3c2': `Job Role cannot be blank`,
's678bad556f8c741c': `Partner ID cannot be blank`,
's73e6604052ffe142': `Company cannot be blank`,
    };
  